// src/theme/foundations/colors.js
export const colors = {
    brand: {
      blue: {
        300: '#84caff',
        500: '#5797d9'
      },
      orange: {
        500: '#f85b3c'
      },
      gray: {
        500: '#667085',
        600: '#617887'
      }
    }
  };